import styled, {
  css,
  FlattenSimpleInterpolation,
  IFalconTheme,
  keyframes,
  Layout,
  StyledComponent,
} from '@se-admin/falcon';
import { Keyframes } from 'styled-components';

interface ISkeletonSectionProps {
  height?: string;
  width?: string;
  padding?: string;
  background?: boolean;
  centered?: boolean;
  marginTop?: string;
  marginBottom?: string;
  button?: boolean;
  borderRadius?: string;
}

const ANIMATION_BACKGROUND_CENTER: number = 468;

export const loadingSkeletonAnimation: Keyframes = keyframes`
0% {
  background-position: -{${ANIMATION_BACKGROUND_CENTER}}px 0;
}

100% {
  background-position: ${ANIMATION_BACKGROUND_CENTER}px 0;
}
`;

export const skeletonAnimationStyles: FlattenSimpleInterpolation = css`
  -webkit-animation-duration: 1.2s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: ${loadingSkeletonAnimation};
  -webkit-animation-timing-function: linear;
  background: #f5f5f5;
  background-image: linear-gradient(
    90deg,
    rgba(250, 250, 250, 0) 25%,
    #fafafa 50%,
    rgba(250, 250, 250, 0) 100%
  );
  background-repeat: no-repeat;
`;

export const LoadingSkeletonSection: StyledComponent<
  typeof Layout.Container,
  IFalconTheme,
  ISkeletonSectionProps
> = styled(Layout.Container)(
  ({
    height,
    width,
    padding,
    theme,
    background,
    centered,
    marginTop,
    marginBottom,
    borderRadius,
  }: { theme: IFalconTheme } & ISkeletonSectionProps) => {
    return css`
      height: ${height ? height : '200px'};
      width: ${width ? width : '100%'};
      margin: ${centered ? '0 auto' : padding ? padding : '0'};
      ${marginTop ? `margin-top: ${marginTop};` : ''}
      ${marginBottom ? `margin-bottom: ${marginBottom};` : ''}
      background: ${background ? theme.color.grey20 : null};
      position: relative;
      overflow: hidden;
      ${borderRadius ? `border-radius: ${borderRadius};` : ''}
      ${skeletonAnimationStyles}
    `;
  }
);
